import React from 'react';

import { IconButton, Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import { AlineAvatar, Spacer } from 'src/components';
import type { GroupUserRow } from 'src/components/admin';
import { useAccessGuard } from 'src/components/auth';
import { TrashcanIcon } from 'src/components/icons/TrashcanIcon';
import { Apollo } from 'src/gql/generated';
import { useRemoveUsersFromGroup } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  button: {
    marginLeft: theme.spacing(1),
    visibility: 'hidden',
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },
  primaryText: {
    marginLeft: theme.spacing(1),
  },
}));

export function GroupUserCell({ row }: GridCellParams): JSX.Element {
  const { classes } = useStyles();
  const { removeUsersFromGroup } = useRemoveUsersFromGroup();
  const typedRow = row as GroupUserRow;
  const handleRemoveUser = useAccessGuard({
    callback: async () => {
      await removeUsersFromGroup(typedRow.groupId, {
        variables: { input: { id: typedRow.groupId, userIds: [typedRow.user.id] } },
      });
    },
    minRole: Apollo.OrgRole.Admin,
  });

  return (
    <div className={classes.container}>
      <AlineAvatar avatarInfo={typedRow.user} />
      <Typography className={classes.primaryText}>{typedRow.user.displayName}</Typography>
      <Spacer />
      <IconButton
        color="primary"
        size="small"
        // Capture the event in the capture cycle and prevent propagation so the click on the menu button doesn't select/de-select the associated row.
        onClickCapture={async e => {
          e.stopPropagation();
          await handleRemoveUser();
        }}
      >
        <TrashcanIcon />
      </IconButton>
    </div>
  );
}
